/* eslint-disable no-labels */
/* eslint-disable no-unused-labels */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-boolean-value */

import React, { Component } from 'react';
import { find } from 'lodash';
import { Grid } from 'semantic-ui-react';
import { SlideDown } from 'react-slidedown';
import { connect } from 'react-redux';

function CollapseableBox(WrappedComponent) {
  class CollapsableParameter extends Component {
    constructor(props) {
      super(props);

      this.state = {
        visible: true
      };

      this.setVisibleSection = this.setVisibleSection.bind(this);
    }

    setVisibleSection() {
      const { visible } = this.state;
      this.setState({
        visible: !visible
      });
    }

    render() {
      const { layer, rank, title } = this.props;
      const { visible } = this.state;
      const sliderVisible = layer ? visible : false;

      return (
        <div className="configurationBox">
          <Grid>
            <Grid.Row className="parameterHeader">
              <Grid.Column width={2} className="stepBox">
                {rank}
              </Grid.Column>
              <Grid.Column width={12}>{title}</Grid.Column>
              <Grid.Column width={2} className={`toggle ${visible ? '' : 'closed'}`}>
                <i className="icon icon-play3 clickable" onClick={this.setVisibleSection} />
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <SlideDown closed={!sliderVisible} className="boxContent">
            {layer && <WrappedComponent {...this.props} />}
          </SlideDown>
        </div>
      );
    }
  }

  return connect(state => ({
    layer: (() => {
      const { activeLayerId } = state.analysis.single;
      return find(state.analysis.single.layers, { id: activeLayerId });
    })()
  }))(CollapsableParameter);
}

export default CollapseableBox;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/CollapseableBox.js